import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { useGetPaymentOrderGroupsResponseRow } from './useGetPaymentOrderGroups';

export default function useCreatePaymentOrderGroups() {
  const [loading, setLoading] = useState(false);

  async function execute(): Promise<
    useGetPaymentOrderGroupsResponseRow[] | undefined
  > {
    try {
      setLoading(true);
      const response = await api.post(
        `/v1/backoffice/payment-order-groups:process-issued-payment-orders`,
      );

      if (response.status === 201) {
        return response.data;
      }
      return [];
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
